<script>
    import WidgetBox from './WidgetBox.svelte';
    import MenuItem from './MenuItem.svelte';
    import ShareDialog from './ShareDialog.svelte';
    import StandaloneButton from "./util/StandaloneButton.svelte";
    import ExampleButton from './util/ExampleButton.svelte';
    import { onMount } from 'svelte';

    let showShare = false;

    onMount(() => {
        window.scrollTo({left: 0, top: 0});
    });

</script>

<style>

</style>

<WidgetBox left="hide" showReset={false} homeLinkHref="#/" homeLinkText="Intro">

    <div slot="title">
        <span style="font-size: 0.9em">Nonsense Laboratory</span>
    </div>
    
    <div slot="tagline">
        Select a tool from the laboratory to play with!
    </div>

    <div slot="widget">
        <MenuItem
                href="#/mixer?popOut=1"
                icon="assets/svg/_menu-large-blue.svg"
                animDefault="assets/images/menu-mixer.png"
                animActivated="assets/images/menu-mixer.apng">
            <div slot="name">Mixer</div>
            <div slot="desc">Mix together existing words to make new meanings</div>
        </MenuItem>
        <MenuItem
                href="#/mouthfeel?popOut=1"
                icon="assets/svg/_menu-large-cyan.svg"
                animDefault="assets/images/menu-tuner.png"
                animActivated="assets/images/menu-tuner.apng">
            <div slot="name">Mouthfeel Tuner</div>
            <div slot="desc">Change how text feels in your mouth</div>
        </MenuItem>
        <MenuItem
                href="#/respeller?popOut=1"
                icon="assets/svg/_menu-large-orange.svg"
                animDefault="assets/images/menu-respeller.png"
                animActivated="assets/images/menu-respeller.apng">
            <div slot="name">Respeller</div>
            <div slot="desc">Spell the sound of a text with different letters</div>
        </MenuItem>
        <MenuItem
                href="#/sequencer?popOut=1"
                icon="assets/svg/_menu-large-red.svg"
                animDefault="assets/images/menu-sequencer.png"
                animActivated="assets/images/menu-sequencer.apng">
            <div slot="name">Sequencer</div>
            <div slot="desc">Invent new words by sequencing mouth movements</div>
        </MenuItem>
        <MenuItem
                href="#/explorer?popOut=1"
                icon="assets/svg/_menu-large-purple.svg"
                animDefault="assets/images/menu-explorer.png"
                animActivated="assets/images/menu-explorer.apng">
            <div slot="name">Explorer</div>
            <div slot="desc">Investigate an endless field of nonsense</div>
        </MenuItem>

        <div style="display: flex; justify-content: center;">
            <StandaloneButton id="share" title="Share" on:click={() => {showShare = true;}}>Share the Experiment</StandaloneButton>
        </div>

        {#if showShare}
            <ShareDialog on:close={() => { showShare = false; }}/>
        {/if}

    </div>

    <div slot="modalContent">

        <h4>General help</h4>

        <p>Select a tool from the Nonsense Laboratory to play with!
           Whenever you see <ExampleButton src="assets/svg/_help-small.svg" alt="Help"></ExampleButton>,
           it means you can hover or tap nearby text to reveal a tooltip
           with information about what the text means.</p>
        
        <h4>Credits</h4>

        <p><a href="https://www.decontextualize.com/">Allison Parrish</a>
        came up with the idea for the Nonsense Laboratory,
        and was the programmer and creative director on the project.
        <a href="https://www.jennygoldstick.com/">Jenny Goldstick</a> and
        <a href="http://timszetela.com/">Tim Szetela</a> designed the visuals and user experience.
        Thank you to <a href="https://hollygrimm.com/">Holly Grimm</a> for creating several
        early prototypes of the Nonsense Laboratory, including the initial port of Pincelate to JavaScript.</p>

        <p>April 2021</p>
            
    </div>

</WidgetBox>

